import React from "react";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUploadAlt, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useSyncOnesky } from "../queries/use-sync-onesky";

export const SyncOneskyButton = ({ projectId, version }) => {
  const { mutate, isLoading } = useSyncOnesky(projectId, version);
  return (
    <>
      <button
        type="button"
        disabled={isLoading}
        className={classnames([
          "inline-flex items-center gap-2 h-9 px-4 rounded-full bg-green-500 text-white text-sm font-semibold shadow-sm hover:opacity-95 transition",
          {
            "opacity-50 cursor-not-allowed": isLoading,
          },
        ])}
        onClick={() => mutate()}
      >
        <FontAwesomeIcon
          className={classnames([
            "w-3.5 h-3.5",
            {
              "animate-spin": isLoading,
            },
          ])}
          icon={isLoading ? faSpinner : faCloudUploadAlt}
        />
        Sync Onesky
      </button>
    </>
  );
};
